import { PageHeader } from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import { CTASection } from "@/components/common/CTASection";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { FAQ } from "@/data/content";

export default function FAQPage() {
  return (
    <div data-testid="faq-page">
      <PageHeader
        overline="FAQ"
        titleLines={["Answers, before", "you ask."]}
        lead="Everything creators and ambassadors want to know about how FanFuel works, what it costs, and how your control is protected."
        testid="faq-header"
      />

      <section className="px-5 py-14 md:px-8 md:py-20">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQ.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-white/10"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="py-6 font-display text-lg font-semibold text-ff-ivory hover:no-underline [&[data-state=open]]:text-ff-ember md:text-xl">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-base leading-relaxed text-ff-grey">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>

      <CTASection title="Still have questions? Apply and ask us." secondaryLabel="Privacy & Trust" secondaryTo="/privacy-trust" />
    </div>
  );
}
